import { useCallback } from 'react';
import { useMutation } from '@ts-core/lib/apollo';
import find from 'lodash/find';

import { useMutationCompletionHandler } from '@ts-core/lib/apollo';

import { addStudentsToGroupMutation } from '../graphql/mutations';

import useGroups from './useGroups';

export default function useGroup({ courseId, groupId, onStudentsAddedToGroup }) {
  const { onError } = useMutationCompletionHandler();

  const { groups, loading } = useGroups({ courseId });

  const group = find(groups, { _id: groupId }) || {};

  /**
   * Add Students to group
   */
  const [addStudentsToGroup, { loading: addingStudentsToGroup }] = useMutation(addStudentsToGroupMutation, {
    onError,
    onCompleted: onStudentsAddedToGroup,
  });
  const onAddStudentsToGroup = useCallback(
    (students) => {
      addStudentsToGroup({
        variables: {
          courseId,
          groupId,
          input: {
            students: students.map((s) => s._id),
          },
        },
      });
    },
    [addStudentsToGroup, courseId, groupId]
  );

  return {
    group,
    loading,

    onAddStudentsToGroup,
    addingStudentsToGroup,
  };
}
